<script lang="ts">
  let {
    active = $bindable(false),
    size,
    onchange = () => {},
    id = ""
  }: {
    active?: boolean
    size?: string
    onchange?: (active: boolean) => void
    id?: string
  } = $props()
</script>

<div
  class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-indigo-600 transition-colors duration-200 ease-in-out has-checked:bg-green-500 has-focus-visible:outline-2"
>
  <span
    class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"
  ></span>
  <input
    type="checkbox"
    bind:checked={active}
    class="absolute inset-0 appearance-none focus:outline-hidden"
    aria-label="Switch"
    name="switch"
    {id}
    onchange={(e: any) => onchange(e.target.checked)}
  />
</div>
